// extracted by mini-css-extract-plugin
export default {"container":"sponsor_container__2u7vo"};